module.exports = __webpack_public_path__ + "9dc476334d564307042640c62f7b69e7.svg";